import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesMail } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_GetMailTemplates = z.array(schemaTemplatesMail);

export type SchemaTemplateResolver_GetMailTemplates = z.infer<typeof schemaTemplateResolver_GetMailTemplates>;

export type TemplateResolver_GetMailTemplates = Resolver<Arguments, SchemaTemplateResolver_GetMailTemplates>;
